<template>
	<md-field :class="[{ 'md-error': error }]">
		<label>{{ $t('signUp.role.hint') }}</label>
		<TbSelect v-model="moduleValue"
				  :options="options"
				  options-value-field="key"
				  options-display-field="name"
				  @md-selected="onSelect"
				  :required="true"
		/>
		<span v-if="error" class="validation-error">{{ error }}</span>
	</md-field>
</template>
<script>
import {enumDef} from "@/common/enumDefs";

export default {
	props: {
		value: { type: String, default: "" },
		error: { type: Boolean, default: "" }
	},
	data() {
		return {
			moduleValue: ""
		};
	},
	mounted() {
		this.moduleValue = this.value;
	},
	computed: {
		options() {
			return Object.keys(enumDef.traderType.properties)
				.map(key => {
					return {
						key: key,
						name: this.$t(enumDef.traderType.properties[key].key)
					};
				});
		}
	},
	methods: {
		onSelect() {
			this.$emit("input", this.moduleValue);
		}
	},
	watch: {
		value() {
			this.moduleValue = this.value;
		}
	}
};
</script>
